import React from 'react';
import Login from '../components/Login';

const DietitianRegister: React.FC = () => {
  return <Login userRole="dietitian" isRegister={true} />;
};

export default DietitianRegister;

